import { WidgetProps } from '../../models/widget.model';
import { useEffect, useState } from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { State, process } from '@progress/kendo-data-query';
import DataGrid from '../datagrid/DataGrid';
import {
  AlignmentChangeCell,
  AlignmentTextCell,
  DateCell,
} from './widget-subcomponents/TreeList.subcomponents';
import ProfileCell from '../flyouts/ProfileCell';

import { ListResponse } from '../../store/api/chart.api';
import { ColumnModel } from 'common/models/widget-config.model';

export const columns: ColumnModel[] = [
  {
    field: 'profile',
    title: 'Profile',
    sortable: true,
    cell: ({ dataItem }: any) => {
      return <ProfileCell dataItem={dataItem} selectedTab={0} />;
    },
  },
  {
    field: 'change',
    title: 'Change',
    sortable: true,
    filter: 'numeric',
    cell: AlignmentChangeCell,
  },
  {
    field: 'previousAlignmentLabel',
    title: 'Previous Alignment',
    sortable: true,
    filter: 'text',
    cell: (e: GridCellProps) => {
      if (e?.dataItem['prevAlignment'] !== undefined) {
        return AlignmentTextCell(
          e?.dataItem['prevAlignment'],
          e?.dataItem['alignmentChangeScore'],
          e?.dataItem['previousAlignmentColor1'],
          e?.dataItem['previousAlignmentColor2'],
          e?.dataItem['previousAlignmentLabel']
        );
      }
      return <td></td>;
    },
  },
  {
    field: 'prevDate',
    title: 'Previous Date',
    sortable: true,
    filter: 'date',
    cell: (e: GridCellProps) => DateCell(e?.dataItem['prevDate']),
  },
  {
    field: 'alignmentLabel',
    title: 'Latest Alignment',
    sortable: true,
    filter: 'text',
    cell: (e: GridCellProps) =>
      AlignmentTextCell(
        e?.dataItem['latestAlignment'],
        e?.dataItem['alignmentChangeScore'],
        e?.dataItem['alignmentColor1'],
        e?.dataItem['alignmentColor2'],
        e?.dataItem['alignmentLabel']
      ),
  },
  {
    field: 'nextDate',
    filter: 'date',
    title: 'Latest Date',

    sortable: true,
    cell: (e: GridCellProps) => DateCell(e?.dataItem['nextDate']),
  },
];

export default function WidgetAlignmentShift({ data, id, groupable }: WidgetProps<ListResponse>) {
  const [filteredData, setFilteredData] = useState(data.data);
  const [dataState, setDataState] = useState<State>(data as State);
  const [dataResult, setDataResult] = useState(process(filteredData, dataState));

  const dataStateChange = (event: any) => {
    setDataResult(process(filteredData, event.dataState));
    setDataState(event.dataState);
  };

  useEffect(() => {
    setFilteredData(data.data);
    setDataState(data as State);
    setDataResult(process(data.data, data as State));
  }, [data]);

  return (
    <DataGrid
      widgetId={id}
      className="treelist-grid-category-response"
      onDataStateChange={dataStateChange}
      {...dataState}
      groupable={groupable}
      total={data.total}
      sortable={true}
      data={dataResult}
      columns={columns}
    />
  );
}
